module.exports = __webpack_public_path__ + "static/media/Yrsa-Regular.7abc7135.ttf";